export const updatePromptList = (
  prevPrompts,
  intelligence_chat_id,
  intelligenceChat,
  isDescription = false
) => {
  if (prevPrompts?.[0]?.id === intelligence_chat_id) {
    if (isDescription) {
      const nextPrompts = [...prevPrompts];
      nextPrompts[0] = {
        id: intelligence_chat_id,
        name: intelligenceChat?.name || 'New Note',
        description: intelligenceChat?.description || '',
        noteType: intelligenceChat?.noteType
      };
      return nextPrompts;
    }
    return prevPrompts;
  }
  const newPrompt = {
    id: intelligence_chat_id,
    name: 'New Note',
    description: intelligenceChat?.description || '',
    noteType: intelligenceChat?.noteType
  };
  return [newPrompt, ...prevPrompts];
};
